<template>
    <b-card body-class="p-3 review-types-view">
        <div class="form-sample checkofftypes">
            <div class="d-flex title-bar-block mb-2">
                <div class="icon-block me-4">
                    <button id="cancel-label-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                        <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                    </button>
                </div>
                <div class="text">
                    <span class="me-2">{{ title }}</span>
                </div>
            </div>
            <b-tabs card align="center" v-model="localTabIndex" class="mt-2">
                <b-tab :title="$translate('summary')" class="p-0 mt-3">
                    <b-card-body class="p-0">
                        <b-overlay :show="loading" rounded="sm">
                            <b-form @submit.stop.prevent="onSubmit">
                                <b-col>
                                    <label class="mb-3" for="input-name"><strong>{{ $translate('name') }}<span
                                                class="red">*</span></strong>
                                    </label>
                                    <b-form-input type="text" id="input-name" v-model="model.name" required
                                        v-custom-validation="$textRequired()" :placeholder="$translate('enter_name')"
                                        trim></b-form-input>
                                </b-col>
                                <b-col class="mt-3">
                                    <label class="mb-3" for="input-description"><strong>{{ $translate('description')
                                    }}</strong>
                                    </label>
                                    <b-form-input type="text" id="input-description" v-model="model.description"
                                        :placeholder="$translate('enter_description')" trim></b-form-input>
                                </b-col>

                                <b-col class="mt-3">
                                    <label class="mb-3" for="input-reasons"><strong>{{ $translate('reasons') }}</strong>
                                    </label>
                                    <b-form-input type="text" id="input-reasons" v-model="model.reasons"
                                        :placeholder="$translate('enter_reasons')" trim></b-form-input>
                                </b-col>
                                <b-col class="my-4 d-flex gap-3">
                                    <b-col cols="auto" class="d-flex">
                                        <div class="form-check">
                                            <label class="form-check-label">
                                                <input type="checkbox" id="input-enforced" v-model="model.enforced"
                                                    name="input-enforced" :value="1" :unchecked-value="0" />
                                                <i class="input-helper"></i>
                                            </label>
                                        </div>
                                        <label for="input-enforced" class="mb-2 ms-2"><strong>{{ $translate('mandatory')
                                        }}</strong>
                                        </label>
                                    </b-col>
                                    <b-col cols="auto" class="d-flex">
                                        <div class="form-check">
                                            <label class="form-check-label">
                                                <input type="checkbox" id="input-do_release" name="input-do_release"
                                                    v-model="model.do_release" :value="1" :unchecked-value="0" />
                                                <i class="input-helper"></i>
                                            </label>
                                        </div>
                                        <label for="input-do_release" class="mb-2 ms-2"><strong>{{ $translate('do_release')
                                        }}</strong>
                                        </label>
                                    </b-col>
                                    <b-col cols="auto" class="d-flex">
                                        <div class="form-check">
                                            <label class="form-check-label">
                                                <input type="checkbox" id="input-attachment_require"
                                                    v-model="model.attachment_require" name="input-attachment_require"
                                                    :value="1" :unchecked-value="0" />
                                                <i class="input-helper"></i>
                                            </label>
                                        </div>
                                        <label for="input-attachment_require" class="mb-2 ms-2"><strong>{{
                                            $translate('attachment_require')
                                        }}</strong>
                                        </label>
                                    </b-col>
                                    <b-col cols="auto" class="d-flex">
                                        <div class="form-check">
                                            <label class="form-check-label">
                                                <input type="checkbox" id="input-signature_require"
                                                    v-model="model.signature_require" name="input-signature_require"
                                                    :value="1" :unchecked-value="0" />
                                                <i class="input-helper"></i>
                                            </label>
                                        </div>
                                        <label for="input-signature_require" class="mb-2 ms-2"><strong>{{
                                            $translate('signature_require')
                                        }}</strong>
                                        </label>
                                    </b-col>
                                    <b-col cols="auto" class="d-flex">
                                        <div class="form-check">
                                            <label class="form-check-label">
                                                <input type="checkbox" id="input-ext_acc_bill_generate"
                                                    v-model="model.ext_acc_bill_generate" name="input-ext_acc_bill_generate"
                                                    :value="1" :unchecked-value="0" />
                                                <i class="input-helper"></i>
                                            </label>
                                        </div>
                                        <label for="input-ext_acc_bill_generate" class="mb-2 ms-2"><strong>{{
                                            $translate('ext_acc_bill_generate')
                                        }}</strong>
                                        </label>
                                    </b-col>
                                </b-col>

                                <b-col cols="12" class="mt-3 mb-2">
                                    <div class="d-flex gap-2 justify-content-center">
                                        <b-button id="create-btn" class="btn btn-info btn-fw" type="submit"
                                            v-if="hasPermissionCreate && !model.id" variant="primary"
                                            :disabled="loading ? true : false">{{ createLabel }}</b-button>
                                        <b-button id="update-btn" class="btn btn-info btn-fw" type="submit"
                                            v-if="hasPermissionUpdate && model.id" variant="primary"
                                            :disabled="loading ? true : false">{{ updateLabel }}</b-button>
                                        <b-button id="delete-btn" v-if="model.id && hasPermissionDelete" size="fw"
                                            @click="deleteCheckoffType()" variant="delete-button">
                                            {{ $deleteLabel() }}
                                        </b-button>
                                        <b-button id="cancel-btn" variant="info" class="btn-fw" :disabled="loading ? true : false"
                                            @click="cancel()">{{ $cancelLabel() }}</b-button>
                                    </div>
                                </b-col>
                            </b-form>
                        </b-overlay>
                    </b-card-body>
                </b-tab>
                <b-tab :title="$translate('roles')" class="p-0" >
                    <CheckoffTypeRoles v-if="!!item.id" />
                </b-tab>
            </b-tabs>
        </div>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import CheckoffTypeRoles from './CheckoffTypeRoles.vue'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'reviewTypes-view-item',
    mixins: [popupMixins, permissionsMixins],
    props: ['item', 'tabIndex'],
    components: { CheckoffTypeRoles },
    data() {
        return {
            loading: false,
            localTabIndex: this.tabIndex,
            model: {
                id: 0,
                name: null,
                description: null,
                reasons: null,
                attachment_require: null,
                ext_acc_bill_generate: null,
                enforced: null,
                do_release: null,
            },
            updating: false,
            submitting: false,
            hasErrors: false,
        }
    },
    computed: {
        title() {
            return this.model.id ? this.$translate('review_types') : this.$translate('create_review_type')
        },
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) this.model = this.item
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        async onSubmit() {
            try {
                this.loading = true
                const model = { ...this.model }
                const path = model.id
                    ? 'checkoffTypes/update'
                    : 'checkoffTypes/create'
                const valid = this.$validator.validate()
                if (valid) {
                    this.loading = true
                    model.enforced = model.enforced ? 1 : 0
                    model.do_release = model.do_release ? 1 : 0
                    model.attachment_require = model.attachment_require ? 1 : 0
                    model.signature_require = model.signature_require ? 1 : 0
                    model.ext_acc_bill_generate = model.ext_acc_bill_generate ? 1 : 0
                    const result = await this.$store.dispatch(path, model)
                    let action,message
                    if (this.model.id) {
                        action = this.$translate('updated')
                        message = this.$translate('update_alert')
                    } else {
                        action = this.$translate('created')
                        message = this.$translate('create_alert')
                        this.$emit('show-item', result.id)
                    }
                    this.$emit('success', action, model.name, message)
                } else {
                    this.loading = false
                }
            } catch (error) {
                this.$emit('danger', this.$translate('error'), error.message)
            }
            finally {
                this.loading = false
            }
        },
        deleteCheckoffType() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            // const path = 'checkoffTypes/delete'
            const path = 'checkoffTypes/delete'
            const action = model.id ? 'update' : 'create'

            // Generate and display confirmation prompt
            const title = this.$translate('delete_review_type')
            const message = `${this.$translate('delete_note')} ${model.name}?`
            // const errorMsg = 'Unable to delete Review Type!'
            const alertMsg = this.$translate('delete_alert')

            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.loading = true;
                    this.$store
                        .dispatch(path, model.id)
                        .then(() => {
                            this.loading = false;
                            this.$emit(
                                'success',
                                this.$translate('deleted'),
                                model.name,
                                alertMsg,
                                action
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.loading = false;
                            this.doToast(
                                this.$translate('error'),
                                this.$translate('unable_alert'),
                                'danger'
                            )
                        })
                } else {
                    this.loading = false;
                }
            })
        },
    },
}
</script>
<style></style>